export default "__VITE_ASSET__DT8TPlmp__"